import { useCallback } from "react";

import { Button } from "@skydio/rivet-ui";

import { useDispatch, useSelector } from "hooks/redux";
import { isMapShown } from "state/flight_player/selectors";
import { flightPlayerActions } from "state/flight_player/slice";

import type { FC } from "react";

/**
 *
 * @returns A button that shows the drone on the map when clicked.
 * @description This button is only shown when the map is not already shown.
 * This is used on the Parachute audible alert and action button, so that the user can
 * quickly see the drone on the map when the parachute is deployed (if the map is not already shown).
 */
const ShowDroneOnMapButton: FC = () => {
  const dispatch = useDispatch();
  const mapShown = useSelector(isMapShown);
  const handleClick = useCallback(() => {
    dispatch(flightPlayerActions.setPanes(["video", "map"]));
    // set primary video track to map so that the pips show up on the map
  }, [dispatch]);
  if (mapShown) {
    return null;
  }
  return <Button onClick={handleClick}>Show Drone on Map</Button>;
};

export default ShowDroneOnMapButton;
